import { FormattedMessage, useIntl } from 'react-intl';

import { IProfileProps } from './profile.models';
import { ProfileForm } from './profile-form';
import { ContentWrapper } from '../../../common/content-wrapper';
import { Box, ResponsiveMargins } from '../../../common/box';
import { Preloader } from '../../../common/preloader';
import { TechIssues } from '../../../common/tech-issues';
import { SECONDARY_BACKGROUND } from '../../../../constants';
import { Page } from '../page/page';

export const Profile = ({
  onProfileUpdate, profileData, validationSchema, isError, isLoading, updateQuery,
}: IProfileProps): JSX.Element => {
  const intl = useIntl();

  const renderProfileForm = () => {
    if (isLoading) {
      return <Preloader />;
    }

    if (isError) {
      return <TechIssues />;
    }

    return (
      <Page
        title={intl.formatMessage({ id: 'profilePage.title' })}
        description={intl.formatMessage({ id: 'profilePage.description' })}
        style={`body {background-color: ${SECONDARY_BACKGROUND};}`}
      >
        <ContentWrapper withoutPaddings>
          <Box
            responsiveMargins={ResponsiveMargins.sm}
            title={(
              <span data-testid="profile-title">
            <FormattedMessage
              id="profile.title"
            />
          </span>
            )}
            isBackButton
          >
            <ProfileForm
              onSubmit={onProfileUpdate}
              profileData={profileData!}
              updateProfileQuery={updateQuery!}
              validationSchema={validationSchema}
            />
          </Box>
        </ContentWrapper>
      </Page>
    );
  };

  return <>{renderProfileForm()}</>;
};
